// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xml:space='preserve'
    viewBox='0 0 88 22'
    ...attributes
  ><path
      d='M9 0h4c5 0 9 4 9 9v4c0 5-4 9-9 9H9c-5 0-9-4-9-9V9c0-5 4-9 9-9'
      style='fill:var(--icon-bg-color, black)'
    /><path
      d='M17 22H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h12c2.8 0 5 2.2 5 5v12c0 2.8-2.2 5-5 5M3.3 2.4c-.5 0-.9.4-.9.9 0 .2.1.4.2.6V4l3.2 3.2c.3.3.4.7.4 1v5.6c0 .4-.2.8-.4 1L2.6 18v.1c-.3.4-.3 1 .1 1.3.2.1.4.2.6.2.3 0 .5-.1.7-.3l3.2-3.1c.3-.3.7-.4 1-.4h5.7c.4 0 .8.2 1 .4l3.2 3.2h.1c.2.1.4.2.6.2.5 0 .9-.4.9-.9 0-.2-.1-.4-.2-.6l-3.2-3.2c-.3-.3-.4-.7-.4-1V8.2c0-.4.2-.8.4-1l3.1-3.1c.4-.3.5-.9.1-1.3-.2-.2-.4-.3-.7-.3-.2 0-.3.1-.5.1-.1 0-.1.1-.1.1L15 5.9c-.3.3-.7.4-1 .4H8.2c-.4 0-.8-.2-1-.4L3.9 2.7h-.1c-.1-.2-.3-.3-.5-.3'
      style='fill:var(--icon-color, #00ffba)'
    /><path
      d='M9.1 8H13c.6 0 1.1.5 1.1 1.1V13c0 .6-.5 1.1-1.1 1.1H9.1c-.6 0-1.1-.5-1.1-1.1V9.1C8 8.5 8.5 8 9.1 8'
      style='fill:var(--icon-color, #00ffba)'
    /><path
      d='M31.5 7h3C36 7 37 7.9 37 9.2c0 .8-.5 1.4-1.1 1.7.8.2 1.5.8 1.5 1.8 0 1.3-1.1 2.2-2.7 2.2h-3.2zm2.8 3.1c.5 0 .8-.4.8-.7 0-.4-.3-.7-.8-.7h-.9v1.5h.9zm.3 3.2c.5 0 .8-.3.8-.8s-.4-.8-.9-.8h-1.1v1.6zM47.5 11c0 2.3-1.7 4.1-4.1 4.1s-4.1-1.8-4.1-4.1 1.7-4.1 4.1-4.1 4.1 1.8 4.1 4.1m-6.3 0c0 1.3.8 2.3 2.1 2.3s2.1-1 2.1-2.3-.8-2.3-2.1-2.3c-1.2 0-2.1 1-2.1 2.3m9.7 0-2.4-3.9h2.2l1.4 2.5 1.5-2.5h2.2L53.4 11l2.4 3.9h-2.1l-1.5-2.5-1.5 2.5h-2.1zm6.8-4h5.2v1.7h-3.2v1.4h2.6v1.6h-2.6v1.5H63v1.7h-5.3zm7.6 0h1.9v6.1h3v1.7h-4.9z'
      style='fill:var(--icon-text-color, white)'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'BoxelIconWithText';
export default IconComponent;
